/* @flow */
import { RECEIVE_FOUNDRY_RESPONSE } from '../actions/foundry_response';
import type { Action } from '../actions/types';

export default (state: MetaState = {}, action: Action): MetaState => {
  switch (action.type) {
    case RECEIVE_FOUNDRY_RESPONSE:
      const {  meta_data, about, sailthru } = action.data.page_data;
      return {
        ...meta_data,
        about,
        sailthru
      };
    default:
      return state;
  }
};

type MetaState = Object;
